import { useState } from "react";
import { Users, X, Search } from "lucide-react";
import { Link } from "react-router-dom";
import { prettyPhone } from "../lib/crew";

const initials = (n) => n.split(/\s+/).map((w) => w[0]).join("").slice(0, 2).toUpperCase();

export const CrewChips = ({ crew, selectedId, onPick, onClear }) => {
  const [more, setMore] = useState(false);
  const [q, setQ] = useState("");
  if (!crew) return null;
  const visible = crew.slice(0, 8);
  const hits = crew.filter((c) => !q || `${c.name} ${c.phone || ""} ${c.email || ""} ${c.role || ""}`.toLowerCase().includes(q.toLowerCase()));
  return (
    <div data-testid="crew-chips">
      <div className="flex items-center justify-between">
        <p className="eyebrow flex items-center gap-1"><Users size={12} /> Your crew</p>
        <Link to="/app/crew" className="text-xs text-muted underline-offset-4 hover:underline" data-testid="manage-crew-link">Manage crew</Link>
      </div>
      {crew.length === 0 ? (
        <p className="text-xs text-muted mt-1" data-testid="crew-empty-hint">No saved crew yet — new contacts are saved automatically below.</p>
      ) : (
        <div className="flex gap-2 overflow-x-auto pb-1 mt-2" data-testid="crew-row">
          {visible.map((c) => {
            const sel = c.id === selectedId;
            return (
              <button type="button" key={c.id} className={`filter-chip flex items-center gap-2 ${sel ? "active" : ""}`} onClick={() => (sel ? onClear() : onPick(c))} data-testid={`crew-chip-${c.id}`} data-selected={sel} aria-pressed={sel}>
                <span className="crew-avatar">{initials(c.name)}</span><span className="notranslate" translate="no">{c.name}</span>{sel && <X size={14} />}
              </button>
            );
          })}
          {crew.length > 8 && <button type="button" className="filter-chip" onClick={() => setMore(true)} data-testid="crew-more">More…</button>}
        </div>
      )}
      {more && (
        <div className="sheet-backdrop" onClick={() => setMore(false)} data-testid="crew-sheet-backdrop">
          <div className="sheet" onClick={(e) => e.stopPropagation()} data-testid="crew-sheet">
            <div className="flex items-center justify-between"><p className="eyebrow">Your crew</p><button type="button" className="icon-btn" onClick={() => setMore(false)} aria-label="Close" data-testid="crew-sheet-close"><X size={16} /></button></div>
            <div className="search-row mt-3"><Search size={16} className="text-muted" /><input autoFocus className="flex-1 bg-transparent outline-none" placeholder="Search name, number, role" value={q} onChange={(e) => setQ(e.target.value)} data-testid="crew-sheet-search" /></div>
            <div className="mt-2 max-h-[50vh] overflow-y-auto">
              {hits.map((c) => (
                <button type="button" key={c.id} className="country-item w-full text-left" onClick={() => { onPick(c); setMore(false); }} data-testid={`crew-sheet-item-${c.id}`}>
                  <span className="font-semibold">{c.name}</span>{c.role && <span className="text-xs text-muted ml-2">{c.role}</span>}<span className="block text-xs text-muted">{prettyPhone(c.phone) || c.email}</span>
                </button>
              ))}
              {!hits.length && <p className="text-sm text-muted py-4 text-center">No matches.</p>}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
